import { useState, useEffect } from 'react';
import { map } from 'lodash'

import mPunteadoDB from '../../../documents/Preescolar/materialPunteado.json';

import { Col, Container, Row, Spinner } from 'react-bootstrap';
import ReturnBar from '../../../components/ReturnBar/ReturnBar';
import CardGeneral from '../../../components/Cards/CardGeneral/CardGeneral';
import PdfModal from '../../../components/Modal/PdfModal/PdfModal';
import './MaterialPunteado.scss';

export default function MateriaPunteado() {

    const [showModal, setShowModal] = useState(false);
    const [titleModal, setTitleModal] = useState("");
    const [contentModal, setContentModal] = useState(null);
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        setData(mPunteadoDB);
        setIsLoading(false);
    }, []);

    return (
        <div className="material-punteado">
            <ReturnBar />
            {
                isLoading ? (
                    <div className="material-punteado__loading">
                        <Spinner animation="border" />
                    </div>
                ) : (
                    <Container>
                        <h2 className="material-punteado__titulo">Grafías y Fonemas</h2>
                        <Row>
                            {
                                map(data, items => (
                                    <Col lg={12} md={12} className="gy-5" key={items.id} >
                                        <CardGeneral
                                            element={items}
                                            setShowModal={setShowModal}
                                            setTitleModal={setTitleModal}
                                            setContentModal={setContentModal}
                                        />
                                    </Col>
                                ))
                            }
                        </Row>
                    </Container>
                )
            }

            <PdfModal show={showModal} setShow={setShowModal} title={titleModal}>
                {contentModal}
            </PdfModal>
        </div>
    );
}